$(document).ready(function () {
  // Binds a submit event handler to the form with the ID 'Form_StatusUpdateForm'.
  $("#Form_StatusUpdateForm, #Form_ComplaintSubmissionForm").submit(function (
    e
  ) {
    if (grecaptcha.getResponse().length === 0) {
      e.preventDefault();
      alert("Please complete the captcha");
    }
  });
});
